// extracted by mini-css-extract-plugin
module.exports =  {"ProposalCompletion":"ProposalCompletion__r5h0d","imgContainer":"imgContainer__OwTKX","titleSection":"titleSection__XFeKS"};